module.exports = __webpack_public_path__ + "img/solutionBanner_2.c8c86e16.png";